import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Store } from '../../Apis/storeApis';

// Async Thunk to fetch approved stores
export const fetchApprovedStores = createAsyncThunk(
  'stores/fetchApprovedStores',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Store.getApprovedStores();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred in fetching stores");
    }
  }
);

const initialState ={
  stores: [],
  loading: false,
  error: null,
}

const storeSlice = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    resetStore: ()=> initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApprovedStores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovedStores.fulfilled, (state, action) => {
        state.loading = false;
        state.stores = action.payload.results;
      })
      .addCase(fetchApprovedStores.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStore } = storeSlice.actions;
export default storeSlice.reducer;
